module.exports = __webpack_public_path__ + "assets/img/photolist.c751f2b3.png";